export class Personnel {
    id: number;
    nom: string;
    prenom: string;
    email: string;
    tel: string;
    poste: string;
    service: string;
    client: number;
};